// extracted by mini-css-extract-plugin
export default {"container":"b2-z","list":"c2-z"};